module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mm-7068544f07c5b683b67aeaf8afb43ff1.svg";